export default __webpack_public_path__ + "static/media/info04.ceb49003.png";